import React from 'react';

import { usePermissions } from '../core/PermissionContext';

export interface WithPermissionsOptions {
  fallback?: React.ReactNode;
  disabledTooltip?: string;
  disabledClassName?: string;
}

export function withPermissions(
  resource: string,
  action: string,
  options: WithPermissionsOptions = {},
): <P extends object>(WrappedComponent: React.ComponentType<P>) => React.FC<P> {
  return function WithPermissionsHOC<P extends object>(
    WrappedComponent: React.ComponentType<P>,
  ): React.FC<P> {
    return function WithPermissionsComponent(props: P): React.ReactElement | null {
      const engine = usePermissions();
      const hasAccess = engine.hasPermission(resource, action);

      if (!hasAccess) {
        if (options.fallback !== undefined) {
          return options.fallback as React.ReactElement;
        }
        return null;
      }

      return <WrappedComponent {...props} />;
    };
  };
}
